import { fetchJSON } from '@bonnet/next/fetch';

export default (host, data = {}, id = '') => {

    const errorObject = {
        error: 'Circuit Breaker for /deals is open',
    };

    const hasInvalidDealType = !['cash', 'finance', 'lease'].includes(data.deal?.dealType);
    if (hasInvalidDealType) {
        data.deal.dealType = 'finance';
        if (window && window.newrelic) {
            window.newrelic.addPageAction('DealSubmitError', {
                id: data?.carId,
                component: 'Email',
                message: 'deal creation attempted with invalid deal type. Defaulted to \'finance\'.',
            });
        }
    }

    const options = {
        circuitBreaker: {
            id: 'dealxgSaveDeal',
            timeout: 5000,
            resetTimeout: 30000,
            fallback: errorObject,
            on: {
                timeout: () => {
                    if (window && window.newrelic) {
                        window.newrelic.addPageAction(
                            'ThirdPartyError',
                            {
                                id: data?.carId,
                                component: 'Email',
                                message: 'Circuit Breaker timeout for ExportToDealXgFetcher',
                            }
                        );
                    }
                },
            },
        },
        method: 'POST',
        body: data,
        credentials: 'omit',
        headers: {
            'X-fwd-svc': 'atc',
            Accept: 'application/json',
        },
        onError: (error) => {
            if (window && window.newrelic) {
                window.newrelic.addPageAction(
                    'ThirdPartyError',
                    {
                        id: data?.carId,
                        component: 'Email',
                        message: 'Deal callback returned with no deal ID',
                        status: error?.status,
                        statusDescription: error?.statusText,
                    }
                );
            }
        },
    };

    const endpoint = id ? `deals/id/${id}` : 'deals';

    return fetchJSON(`${host}my-wallet/share-dealxg/${endpoint}`, options);
};
